import { amber, grey } from '@mui/material/colors';

const reportsSx = (theme) => ({
    buttonGroupContainer: {
        maxWidth: '1200px',
        margin: '0 auto',
        paddingLeft: '32px',
        paddingRight: '32px',
    },
    profileLoadingContainer: {
        width: '300px',
    },
    editButton: {
        marginTop: '32px',
    },
    cancelButton: {
        marginLeft: '16px',
        marginTop: '32px',
    },
    buttonInactive: {
        backgroundColor: grey[100],
        color: '#000000',
        '&:hover': {
            backgroundColor: amber[300],
        },
    },
    buttonActive: {
        backgroundColor: amber[600],
        color: '#000000',
        '&:hover': {
            backgroundColor: amber[600],
        },
    },
    searchContainer: {
        marginBottom: '64px',
    },
    searchButtons: {
        margin: '8px',
    },
});

export default reportsSx;
